import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { startRealtime } from '../services/realtime';

export default function RealtimeConnection() {
  const { currentUserId } = useAuth();
  useEffect(() => currentUserId ? startRealtime(currentUserId) : undefined, [currentUserId]);
  return null;
}
